<template>
  <div class="home">
    <headers></headers>
    <customer></customer>
    <template v-if="!mixin_expireObj[userInfo.expire_type].canUseHtml">
      <teacherExpire></teacherExpire>
    </template> 
    <template v-else>
      <template v-if="isAuthorityFlag">
        <el-scrollbar
          style="height: 100%"
          class="content_right_con_scrollbar"
          ref="scrollbar"
        >
      
          <div class="content">
            <div class="content_left">
              <div class="left_btn_box"  v-if="isShowAddCourse(menuTreeList)">
                <el-button
                  type="primary"
                  class="content_left_btn"
                  slot="reference"
                  @click="addCourse"
                  >添加课程</el-button 
                >
              </div>
              <!-- <el-button type="primary" class="content_left_btn" slot="reference" @click="publish">发抖音</el-button> -->
              <el-scrollbar class="content_left_scroll">
                <Menus
                  :data="menuTreeList"
                  @change="handleChange"
                  :editNameObj="{
                    path: 'route_name',
                    title: 'name',
                    src: 'icon',
                  }"
                ></Menus>
              </el-scrollbar>
            </div>
            <div class="content_right">
              <div class="breadCrumbList">
                <span>{{ $route.meta.title }}</span>
                <bread-crumb
                  :data="breadCrumbList"
                  @changeRoute="changeRoute"
                ></bread-crumb>
              </div>
              <div
                class="content_right_con"
                v-loading="isLoading === true"
                element-loading-text="加载中"
                element-loading-spinner="el-icon-loading"
              >
                <router-view></router-view>
              </div>
            </div>
          </div>
        </el-scrollbar>
        <el-dialog
          title="微信扫码绑定"
          :visible.sync="qrCodeVisible"
          width="664px"
          custom-class="wxBind"
          @close="handleClose"
        >
          <div class="qrcode">
            <vue-qr
              :text="wx_url"
              :size="120"
              :logoSrc="require('@/assets/image/logo-231019.png')"
              :margin="0"
            ></vue-qr>
            <p>
              <span>绑定后可在微信公众号</span>
              <span style="color: #0491ff">“豆包知道助手”</span>
              <span>查看实时收益数据并体现</span>
            </p>
            <p style="margin-top: 6px">
              挂载流程：绑定{{currentPlatInfo.label}}号<span style="color: red">（不绑无收益）</span
              >→上传课程→发{{currentPlatInfo.label}}挂载课程。
            </p>
          </div>
        </el-dialog>
        <notice-dialog v-model="showHint" @sure="changePopupprompts({djs: 0})"></notice-dialog>
        <userInfo-dialog v-model="userInfoDialogFlag" :params="userInfoDialogParams" @sure="sureNext"></userInfo-dialog>
      </template>
      <div v-else style="text-align: center;margin-top: 10vh;color: #333;font-size: 28px">暂未开通，请联系对接商务/客服进行开通</div>
    </template>
  </div>
</template>

<script>
import vueQr from "vue-qr";
import Menus from "@/components/menus/menu.vue";
import { mapMutations, mapState, mapActions } from "vuex";
import BreadCrumb from "@/components/breadCrumb/breadCrumb.vue";
import headers from "@/components/headers/headers.vue";
import Customer from '@/components/customer/customer.vue';
import noticeDialog from '@/components/notice/notice.vue'
import UserInfoDialog from '@/components/userInfoDialog/userInfoDialog.vue'
import QualificationIsAdd from '@/components/mixin/qualificationIsAdd.js'
import { authority } from '@/components/mixin/mixin.js'
import messageMixin from '@/components/mixin/messageMixin.js'
import { teacherExpireMixin } from '@/components/teacherExpire/mixin.js'
import teacherExpire from '@/components/teacherExpire/teacherExpire.vue'
import {getPlatInfo} from '@/utils/baseUrl.js'
export default {
  name: "Home",
  mixins: [QualificationIsAdd, authority, messageMixin, teacherExpireMixin],
  data() {
    return {
      flag: false,
      checkBindStatus: 0,
      wx_url: "",
      qrCodeVisible: false,
      timer: null,
      popoverFlag: false,
      // isRouteShow: false,
      // msg: "",
      // code: "",
	    showHint:false, //是否展示提示弹框
      userInfoDialogFlag: false,
      userInfoDialogParams: {
        name: '',
        avatar_url: '',
        desc: ''
      },
      copyUserInfo: {},
      currentPlatInfo: getPlatInfo() // 当前平台信息
    };
  },
  // beforeRouteEnter(to, from, next) {
  //   next((vm) => {
  //     vm.getKsIsApply();
  //     return false;
  //   });
  // },
  
  async created() {
    if (this.$route.meta.id && !localStorage.getItem("breadCrumbList")) {
      let newArr = this.selectTitle(this.menuTreeList, {
        id: this.$route.meta.id,
      });
      this.changeBreadCrumbList(newArr);
    }
    // this.getPopupprompts()
    this.getUserInfo()
    if(this.staticPath=='/'){
      this.getQualificationIsAdd()
    }
  },
   mounted(){
    this.getMessageLackFn()
  //    if(localStorage.getItem('showHint') == 1){
  //       this.showHint = true;
	//  }else{
  //       this.showHint = false;
	//  }
  },
  components: {
    Menus,
    "bread-crumb": BreadCrumb,
    headers,
    "vue-qr": vueQr,
    'notice-dialog': noticeDialog,
    Customer,
    'userInfo-dialog': UserInfoDialog,
    teacherExpire
  },
  computed: {
    ...mapState(["breadCrumbList", "isLoading", "cancelRouteFlag"]),
    ...mapState("permission", ["menuTreeList"]),
    ...mapState('login', ['userInfo']),
    ...mapState('help', ['popuppromptsStatus']),
    djsParams() {
      const {desc, name,  avatar_url} = this.copyUserInfo
      return {
        desc,
        name,
        avatar_url
        // djs: this.popuppromptsStatus && this.popuppromptsStatus.djs
      }
    }
  },
  methods: {
    ...mapMutations(["changeBreadCrumbList"]),
    ...mapMutations('help', ['changePopupprompts']),
    ...mapActions("login", ["checkwechat","getUserInfo"]),
    ...mapActions("bind", ["ksIsApply"]),
    ...mapActions("help", ["popupprompts"]),
		async addCourse(){ //跳转到添加课程
      const pathObj = {
        '/': 'createColumn',
        '/ks/': 'createColumn',
        '/wx/': 'createColumn',
        '/sph/': 'addSmallCourse',
        '/xhs/': 'addSmallCourse',
        '/dd/': 'addSmallCourse',
      }
      if(this.staticPath=='/'){
        let flag = await this.testIsAddProduct()
        if(!flag) {
          return
        }
      }
      this.$router.push(this.staticPath + pathObj[this.staticPath]);
    }, 
    // 	closeHint(){ //关闭提示弹框
    //      this.showHint = false;
    // },
    // async getPopupprompts() {
    //   let res = await this.popupprompts()
    //   if(res.djs) {
    //     this.showHint = true
    //   }
    // },
    isShowAddCourse(data){ //是否显示添加课程按钮
      console.log(data,'data')
      let arr = [];
      function fn(newArr){
        newArr.forEach(item=>{
          if(item.name){
            arr.push(item.name)
          }
          if(item.children){
            fn(item.children)
          }
        })
      }
      fn(data)
      return arr.some(item=>{ return item == '课程管理' })
      // console.log(arr,'arr---------')
    },
    handleChange(obj) {
      if (this.cancelRouteFlag) {
        return;
      }
      let newArr = this.selectTitle(this.menuTreeList, obj);
      this.changeBreadCrumbList(newArr);
      localStorage.removeItem("breadCrumbList");
    },
    selectTitle(data, obj) {
      let arr = [];
      data.forEach((item, index) => {
        if (item.id === obj.id) {
          arr.push({ title: item.name, path: item.route_name });
        } else {
          if (item.children && item.children.length) {
            let a = this.selectTitle(item.children, obj);
            const parentObj = [
              { title: item.name, path: item.route_name },
              ...a,
            ];
            if (a && a.length) {
              arr.push(...parentObj);
            }
          }
        }
      });
      return arr;
    },
    changeRoute(index) {
      // this.flag = true
      // let breadCrumbList = this.breadCrumbList.slice(0, index + 1)
      // localStorage.setItem('breadCrumbList', JSON.stringify(breadCrumbList))
      // this.changeBreadCrumbList(breadCrumbList)
    },
    handleClose() {
      clearTimeout(this.timer);
      localStorage.setItem("wx_url", "");
      localStorage.setItem("isShow", "no");
    },
    // publish() {
    //   this.$router.push("/createDynamic");
    // },
    // async getKsIsApply() {
    //   let res = await this.ksIsApply();
    //   this.isRouteShow = false;
    //   this.code = res.code;
    //   if (res.code != 200) {
    //     this.msg = res.msg;
    //   } else {
    //     // this.getCheckBindStatus();
    //   }
    // },
    getCheckBindStatus() {
      this.wx_url = localStorage.getItem("wx_url");
      let isShow = localStorage.getItem("isShow");
      if (this.wx_url && isShow == "yes") {
        this.timer = setTimeout(async () => {
          let res = await this.checkwechat();
          this.checkBindStatus = res.is_wechat;
          if (this.checkBindStatus == 0) {
            this.getCheckBindStatus();
          } else {
            this.qrCodeVisible = false;
            this.$store.state.login.userInfo.is_wechat = 1
            localStorage.setItem("wx_url", "");
            localStorage.setItem("isShow", "");
            this.sureNext()
            if (this.timer) {
              clearTimeout(this.timer);
            }
            this.$message({
              type: "success",
              message: "绑定成功",
              duration: 3000,
            });
          }
        }, 2000);
        this.qrCodeVisible = true;
      }
    },
    sureNext() {
      this.changePopupprompts({djs: ''})
      const path = this.staticPath === '/ks/' ? this.staticPath+ 'ksAccountIndex' : this.staticPath+ 'dyAccountIndex'
      this.$router.push(path)
    }
  },
  watch: {
	  userInfo(news) {
      this.copyUserInfo = JSON.parse(JSON.stringify(news))
      this.mixin_handleTeacherExpirePop(news)
    },
    djsParams(news) {
      if(news) {
        if(Object.values(this.userInfo).length) {
          let flag = false
          for (const key in this.userInfoDialogParams) {
            if(!this.userInfo[key]) {
              flag = true
            } else {
              this.userInfoDialogParams[key] = this.userInfo[key]
            }
          }
          this.userInfoDialogFlag = flag
          if(!flag) {
            this.getCheckBindStatus()
          }
        }
      }
    },
    $route: {
      immediate: true,
      deep: true,
      handler(news, olds) {
        if (news.meta.leval) {
          let breadCrumbList =
            (localStorage.getItem("breadCrumbList") &&
              JSON.parse(localStorage.getItem("breadCrumbList"))) ||
            this.breadCrumbList;
          breadCrumbList[news.meta.leval] = {
            path: news.path,
            title: news.meta.title,
          };
          this.changeBreadCrumbList(breadCrumbList);
          localStorage.setItem(
            "breadCrumbList",
            JSON.stringify(breadCrumbList)
          );
        }
        if (localStorage.getItem("breadCrumbList")) {
          let breadCrumbList = JSON.parse(
            localStorage.getItem("breadCrumbList")
          );
          let index = breadCrumbList.findIndex(
            (item) => item.path == news.path
          );
          this.changeBreadCrumbList(
            index >= 0 ? breadCrumbList.slice(0, index + 1) : breadCrumbList
          );
        }
        this.flag = false;
        if (olds && news.name !== olds.name) {
          setTimeout(() => {
            this.$refs.scrollbar.wrap.scrollTop = 0;
            this.$forceUpdate();
          }, 500);
        }
      },
    },
    cancelRouteFlag(news) {
      // console.log(news, "oooooooooooooooooo11111");
    },
  },
};
</script>
<style lang="less">
.content_right_con_scrollbar {
  .el-scrollbar__wrap {
    overflow-x: hidden;
  }
}
.wxBind {
  height: 300px;
  .el-dialog__header {
    padding: 16px 24px;
    border-bottom: 1px solid #eeeeee;
    .el-dialog__title {
      font-size: 16px;
      font-weight: 500;
      color: #333333;
      line-height: 24px;
    }
  }
  .el-dialog__body {
    padding: 24px;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .qrcode {
    display: flex;
    flex-direction: column;
    align-items: center;
    p {
      font-size: 14px;
      color: #000000;
      margin-top: 20px;
      span {
        line-height: 20px;
      }
    }
  }
}
.content_left_btn_list {
  li {
    height: 40px;
    text-align: center;
    line-height: 40px;
    list-style: none;
    cursor: pointer;
    &:hover {
      color: #4e70f2;
      background-color: #edf1fe;
    }
    &.active {
      color: #4e70f2;
    }
  }
}
</style>
<style lang="less" scoped>
.home {
  width: 100%;
  height: 100%;
  background: #f7f8f9;
  padding-top: 80px;
  box-sizing: border-box;
  position: relative;
  .content {
    height: 100%;
    display: flex;
    max-width: 1270px;
    min-width: 1270px;
    margin: 0 auto;
    .content_left {
      height: calc(100vh - 80px);
      width: 190px;
      flex-shrink: 0;
      position: sticky;
      top: 0px;
      background-color: #fff;
      overflow: hidden;
      display: flex;
      flex-direction: column;
	  padding-left: 20px;
      .left_btn_box {
        width: 180px;
        height: 38px;
        display: flex;
        margin: 30px 0;
        box-sizing: border-box;
        padding-right: 10px;
      
        .content_left_btn {
          flex: 1;
          box-sizing: border-box;
          padding: 0;
          height: 38px;
          border-radius: 2px;
          color: #fff;
          display: flex;
          justify-content: center;
          align-items: center;
      

        }
      }

      .content_left_scroll {
        flex: 1;
        height: 0;
      }
    }
    .content_right {
      padding: 0px 20px 20px 20px;
      box-sizing: border-box;
      width: calc(100% - 190px);
      display: flex;
      flex-direction: column;
      .content_right_con {
        background-color: #fff;
        flex: 1;
        height: 0;
        padding: 20px;
        box-sizing: border-box;
        overflow-x: hidden;
        box-shadow: 0px 8px 24px 0px rgba(18, 38, 63, 0.03);
        border-radius: 8px;
      }
      .breadCrumbList {
        height: 50px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-shrink: 0;
      }
    }
  }
}
.noPermission {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  .invite {
    margin-top: 30px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
}
</style>
